import { useAxiosInterceptors } from "@/config/axios";
import { addAuthToHeader } from "@/findifyv2-api-ts/base/BaseModulePublicApi";
import { AxiosInstance } from "axios";

type SignupData = {
  email: string,
  password: string,
  password_confirmation: string
  language: string,
}

type LoginData = {
  email: string,
  password: string,
}

type ForgotPasswordData = {
  email: string,
  email_confirmation: string,
}

type ForgotPasswordTokenData = {
  password: string,
  password_confirmation: string,
}


export class PublicAuthenticationApi {
  axiosInstance: AxiosInstance | undefined;
  domain = '';
  token: string | undefined;

  constructor(domain: string, token?: string | undefined) {
    this.domain = domain;
    this.token = token;
    this.axiosInstance = useAxiosInterceptors();
  }

  async login(data: LoginData) {
    const response = await this.axiosInstance!.post(`/front/${this.domain}/authentication/login`, data, { headers: await addAuthToHeader({}, this.token) });
    if (response.status === 201) {
      return response.data;
    }
  };

  async signup(data: SignupData) {
    const response = await this.axiosInstance!.post(`/front/${this.domain}/authentication/signup`, data, { headers: await addAuthToHeader({}, this.token) });
    if (response.status === 201) {
      return response.data;
    }
  };

  async validation(hash: string) {
    const response = await this.axiosInstance!.get(`/front/${this.domain}/authentication/validation/${hash}`, { headers: await addAuthToHeader({}, this.token) });
    if (response.status === 201) {
      return response.data;
    }
  };

  async forgotPassword(data: ForgotPasswordData) {
    const response = await this.axiosInstance!.post(`/front/${this.domain}/authentication/forgot_password`, data, { headers: await addAuthToHeader({}, this.token) });
    if (response.status === 201) {
      return response.data;
    }
  }

  async forgotPasswordTOKEN(token: string, data: ForgotPasswordTokenData) {
    const response = await this.axiosInstance!.post(`/front/${this.domain}/authentication/forgot_password/${token}`, data, { headers: await addAuthToHeader({}, this.token) });
    if (response.status === 201) {
      return response.data;
    }
  }

  async authenticationTest() {
    const response = await this.axiosInstance!.get(`/front/${this.domain}/test`, { headers: await addAuthToHeader({}, this.token) });
    if (response.status === 201) {
      return response.data;
    }
  }
};